import React, { useEffect, useState } from "react";
import LensSpecs from "./LensSpecs";
import SimulatedFit from "./SimulatedFit";
import TrialLens from "./TrialLens";
import { collect, withDiameter } from "./scanResult";

/**
 * A scleral result as three cards: the trial lens to start with, the lens to
 * order, and how it sits. The diameter chosen in Lens Specs drives the trial
 * lens and the Simulated Fit. The trial lens shown and the base curve in
 * Lens Specs are passed up for the power calculation.
 */
export default function ScleralResult({ parameters, createdAt, code, onTrialLens, onOrder }) {
  const base = collect(parameters);
  const [chosen, setChosen] = useState(null);

  // a different result means a different set of diameters
  useEffect(() => setChosen(null), [parameters]);

  const options = base.options;
  const active = options && (options.find((o) => o["Lens Diameter"] === chosen) ||
                             options.find((o) => o["Recommended"]) || options[0]);
  const r = withDiameter(base, active);

  // the power calculation compensates to the base curve of the lens in Lens Specs
  const orderDiameter = typeof r.diameter === "number" ? r.diameter : null;
  const orderBc = typeof r.baseCurve === "number" ? r.baseCurve : null;
  useEffect(() => {
    if (onOrder) onOrder(orderDiameter != null ? { diameter: orderDiameter, bc: orderBc } : null);
  }, [onOrder, orderDiameter, orderBc]);
  useEffect(() => () => { if (onOrder) onOrder(null); }, [onOrder]);

  return (
    <>
      <div className="dash-card dash-result">
        <TrialLens sim={base.simulatedFit} diameter={r.diameter} onLens={onTrialLens} />
      </div>
      <div className="dash-card dash-result">
        <LensSpecs r={r} options={options} onChoose={setChosen} createdAt={createdAt} code={code} sim={base.simulatedFit} />
      </div>
      <div className="dash-card dash-result">
        <SimulatedFit sim={base.simulatedFit} diameter={r.diameter} />
      </div>
    </>
  );
}
